import { useCallback, useState } from 'react';
import styles from './BaseButton.scss';

type ButtonProps = JSX.IntrinsicElements['button'];
type Props = ButtonProps;

/** atoms/BaseButton */
export const BaseButton: React.FC<Props> = ({ children, onClick, disabled, type, ...props }) => {
  const [running, setRunning] = useState(false);

  const _click = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (!onClick) return;

      setRunning(true);
      Promise.resolve(onClick(e)).finally(() => {
        setRunning(false);
      });
    },
    [onClick]
  );

  return (
    <button {...props} onClick={_click} type={type || 'button'} disabled={disabled || running}>
      {children}
      <style jsx>{styles}</style>
    </button>
  );
};
